import React from 'react';
import '../styles/Testimonials.css';

const testimonials = [
  {
    name: 'Erica',
    profession: 'Member • 45+ transformation',
    description:
      "Post 45 I thought I would not be able to lose weight and feel comfortable in my skin again! But I didn't give up and what's more my trainer, Daniella, didn't give up on me! I have reached my goals and I feel fantastic!",
    avatar: '/assets/testimonials/Erica.jpg',
  },
  {
    name: 'Carolyn',
    profession: 'Member • 2+ years',
    description:
      "I have been working with Daniella for over 2 years now and I have to say I have enjoyed every single workout! When you hear her saying 'You Got This', even those last 20secs of the plank seems doable! I don't plan on stopping!!",
    avatar: '/assets/testimonials/Carolyn.jpg',
  },
  {
    name: 'Anuradha',
    profession: 'Member • 60 Day Program',
    description:
      "The reasons are multifold: The way Daniella makes fitness not only fun but effective! I feel energised and confident after completing the 60 days Program and look forward to continuing training with Daniella. I was able to restart my fitness journey and reach my goals without going on any crazy diets! She has truly changed my life!",
    avatar: '/assets/testimonials/Anuradha.jpg',
  },
  {
    name: 'Sajani',
    profession: 'Member • Postpartum',
    description:
      "DAN HELPED ME FIND THE 'NEW ME', I AM FOREVER GRATEFUL. 2 months back I stood in the same place with an unhealed diastasis recti being 4 yrs postpartum and stressed all the time! Dan helped me find the new me. The new me who is confident, enjoys festive foods guilt free, being okay with missing workouts, being a busy mom and coming back the next day stronger!",
    avatar: '/assets/testimonials/Sajani.jpg',
  },
  {
    name: 'Kashmira',
    profession: 'Member • 8 years',
    description:
      "It’s been 8 yrs since I have been hooked onto Get Fit with Daniella! A couch potato is what I would describe myself as before I was introduced to Daniella. Exercise was a burden for me before. Starting fitness with Daniella has been a game changer! Daniella's contagious energy, smile and unique workouts has got me hooked onto fitness for life!",
    avatar: '/assets/testimonials/Kashmira.jpg',
  },
  {
    name: 'Jacqueline',
    profession: 'Member • Everest base camp',
    description:
      "While I trekked I remembered Daniella’s words saying 'You Got This'. Daniella, I have finished the trek to Everest base camp! The Virtually Fit with Daniella workouts I have been doing with you have been a tremendous help in keeping me fit physically and mentally!",
    avatar: '/assets/testimonials/Jacqueline.JPG',
  },
];

const duplicated = [...testimonials, ...testimonials];

export function Testimonials() {
  return (
    <section id="testimonials" className="testimonials-section">
      <div className="testimonials-container">
        <div className="testimonials-header">
          <p className="section-eyebrow">What clients say</p>
          <h2 className="section-title">Real words from happy customers</h2>
        </div>

        <div className="slider-mask">
          <div className="testimonials-track">
            {duplicated.map((item, idx) => (
              <div className="testimonial-pill" key={`${item.name}-${idx}`}>
                <p className="testimonial-quote">“{item.description}”</p>
                <div className="testimonial-footer">
                  <div className="author">
                    <img className="author-avatar" src={item.avatar} alt={item.name} />
                    <div className="author-meta">
                      <span className="author-name">{item.name}</span>
                      <span className="author-role">{item.profession}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
